export default __webpack_public_path__ + "static/media/logo-invision.c6a144e6.svg";